<template>
  <div>
    <mdb-navbar dark position="top" :class="['justify-content-between', { 'nav-transparent': routeName === 'top' }]" scrolling>
      <mdb-navbar-brand to="/">
        <img src="@/assets/images/waaarp_logo_text_wh.png" height="32"/>
      </mdb-navbar-brand>
      <mdb-navbar-nav right>
        <mdb-dropdown v-if="user" tag="li" class="nav-item">
          <mdb-dropdown-toggle tag="a" navLink slot="toggle" waves-fixed>
            <mdb-icon icon="user-circle"/>
            <span class="d-none d-md-inline px-1 font-weight-bold">{{ user.name }}</span>
          </mdb-dropdown-toggle>
          <mdb-dropdown-menu>
            <mdb-dropdown-item @click.native="onClickTop" :class="{ 'disabled': routeName === 'top' }">
              <mdb-icon icon="arrow-circle-left" class="mr-2"/>TOP
            </mdb-dropdown-item>
            <mdb-dropdown-item @click.native="onClickUserSettings" :class="{ 'disabled': routeName === 'user' }">
              <mdb-icon icon="user-circle" class="mr-2"/>個人設定
            </mdb-dropdown-item>
            <mdb-dropdown-item @click.native="onClickAccountSettings" :class="{ 'disabled': routeName === 'account' }">
              <mdb-icon icon="id-card" class="mr-2"/>契約情報
            </mdb-dropdown-item>
            <mdb-dropdown-item @click.native="onClickSignOut">
              <mdb-icon icon="sign-out-alt" class="mr-2"/>ログアウト
            </mdb-dropdown-item>
          </mdb-dropdown-menu>
        </mdb-dropdown>
        <mdb-nav-item v-else exact to="/sign_in" class="mr-4">
          ログイン
        </mdb-nav-item>
      </mdb-navbar-nav>
    </mdb-navbar>
  </div>
</template>

<script>

// libraries
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Header',
  computed: {
    routeName: function() {
      return this.$route.name
    },
    ...mapGetters({
      user: 'auth/user'
    })
  },
  methods: {
    onClickTop: function() {
      this.$router.push({ name: 'top' })
    },
    onClickUserSettings: function() {
      this.$router.push({ name: 'user' })
    },
    onClickAccountSettings: function() {
      this.$router.push({ name: 'account' })
    },
    async onClickSignOut () {
      await this.signOut()
      if (!this.hasSignedIn) {
        this.$router.push({ name: 'signIn' })
      }
    },
    ...mapActions({
      signOut: 'auth/signOut',
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";

.nav-transparent {
  background-color: transparent;
}
.top-nav-collapse {
  background-color: $secondary-color;
}
</style>
